import React from 'react';
import {
	Box,
	Button,
	Flex,
	Heading,
	Stack,
	Spacer,
	Tooltip,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';

import { ProfileField } from '../elements/ProfileField';
import { residenceAddress } from '../data';
import { makeFields } from './utils';

export const Address = ({ state, setter, remove, id, onBlur }) => {
	const { zip, address, startDate, endDate } = makeFields(
		state,
		setter,
		residenceAddress,
		onBlur
	);
	return (
		<Box borderRadius="md" border="1px" borderColor="gray.200" p={4} mb={4}>
			<Flex>
				<Heading pb={6} fontSize={'lg'}>
					{state.address || 'Место проживания'}
				</Heading>
				<Spacer />
				<Button
					leftIcon={<CloseIcon />}
					colorScheme="red"
					variant="solid"
					size="xs"
					name={id}
					onClick={remove}
				>
					Удалить
				</Button>
			</Flex>
			<Stack direction={['column', 'row']}>
				<ProfileField w={['100%', '15%']} pb={6} {...zip} />
				<ProfileField w={['100%', '85%']} pb={6} {...address} />
			</Stack>
			<Tooltip label="Период проживания" placement="top-start">
				<Heading fontSize="lg" pb={6}>
					Residence term
				</Heading>
			</Tooltip>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...startDate} />
				<ProfileField pb={6} {...endDate} />
			</Stack>
		</Box>
	);
};
